import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    /*if (request.url !== 'http://api.foxnuvem.com.my/login' && request.url !== 'http://api.foxnuvem.com.my/register' && request.url !== 'http://mart.foxnuvem.com.my/index.php?route=checkout/add_dexpay') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
    }*/

    
    if (request.url !== 'https://api.dexasia.com.my/ETicketing/Service' && request.url !== 'https://api.dexasia.com.my/login' && request.url !== 'https://api.dexasia.com.my/register' && request.url !== 'https://dexmart.com.my/index.php?route=checkout/add_dexpay' && request.url !== 'https://dexmart.com.my/index.php?route=checkout/posm_api' && request.url !== 'https://dexmart.com.my/index.php?route=checkout/nw_api' && request.url !== 'http://api.ipify.org/?format=json') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
    }

      //dev path
      /*if (request.url !== 'http://api.dexasia.com.my/ETicketing/Service' && request.url !== 'http://api.dexasia.com.my/login' && request.url !== 'http://api.dexasia.com.my/register' && request.url !== 'http://dexmart.com.my/index.php?route=checkout/add_dexpay' && request.url !== 'http://dexmart.com.my/index.php?route=checkout/posm_api' && request.url !== 'http://dexmart.com.my/index.php?route=checkout/nw_api' && request.url !== 'http://api.ipify.org/?format=json') {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
      }*/

    //local path
    /*if (request.url !== 'http://localhost/fusiolocal/login' && request.url !== 'http://localhost/fusiolocal/login' && request.url !== 'http://localhost/fusiolocal/register' && request.url !== 'http://localhost/dex02/index.php?route=checkout/add_dexpay' && request.url !== 'http://localhost/dex02/index.php?route=checkout/posm_api' && request.url !== 'http://localhost/dex02/index.php?route=checkout/nw_api' && request.url !== 'https://api.ipify.org/?format=json') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
    }*/


    return next.handle(request);
  }
}
